import {
  ByCustomerNumberOrIndexFragment,
  CopyHeadAgreementTargetCustomerQuery,
} from "@/gql/graphql";
import {
  createStandardTableInitialState,
  useLocalStateTableContext,
} from "@stenajs-webui/grid";
import * as React from "react";
import { useMemo } from "react";
import { HeadAgreement } from "../types";
import { getIdsForRouteAgreementsToPrefill } from "../util/RouteSelectionPrefiller";
import { CopyHeadAgreement } from "./CopyHeadAgreement";
import { SelectedRouteAgreementColumns } from "./SelectRouteAgreements";

interface Props {
  headAgreement: HeadAgreement;
  targetHeadAgreement?: CopyHeadAgreementTargetCustomerQuery["productPrice"]["headAgreement"]["byId"];
  targetCustomer?: ByCustomerNumberOrIndexFragment;
  copyHaToOtherCustomer?: boolean;
  copyHaFromOtherCustomer?: boolean;
}

export const CopyHeadAgreementContainer: React.FC<Props> = React.memo(
  ({
    headAgreement,
    copyHaToOtherCustomer = false,
    copyHaFromOtherCustomer = false,
    targetHeadAgreement,
    targetCustomer,
  }) => {
    const initialState = useMemo(
      () =>
        createStandardTableInitialState<SelectedRouteAgreementColumns>(
          undefined,
          undefined,
          getIdsForRouteAgreementsToPrefill(headAgreement)
        ),
      [headAgreement]
    );

    const { tableContext } =
      useLocalStateTableContext<SelectedRouteAgreementColumns>(
        "CopyHeadAgreementTable",
        initialState
      );

    return (
      <>
        <CopyHeadAgreement
          headAgreement={headAgreement}
          targetHeadAgreement={targetHeadAgreement}
          tableContext={tableContext}
          copyHaToOtherCustomer={copyHaToOtherCustomer}
          copyHaFromOtherCustomer={copyHaFromOtherCustomer}
          targetCustomer={targetCustomer}
        />
      </>
    );
  }
);
